var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "delete_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#delete_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#8D8A92",
  d: "M4.664 14c-.367 0-.68-.13-.942-.392a1.284 1.284 0 0 1-.391-.941V4a.645.645 0 0 1-.475-.192.645.645 0 0 1-.192-.475c0-.189.064-.347.192-.475a.645.645 0 0 1 .475-.191h2.666c0-.19.064-.348.192-.475A.645.645 0 0 1 6.664 2h2.667c.189 0 .347.064.475.192a.645.645 0 0 1 .191.475h2.667c.189 0 .347.064.475.191a.645.645 0 0 1 .192.475.645.645 0 0 1-.192.475.645.645 0 0 1-.475.192v8.667c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.941.392H4.664Zm1.333-2.667h1.334v-6H5.997v6Zm2.667 0h1.333v-6H8.664v6Z"
}))));
export default SvgDelete;